var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-text module module--mb container"},[_c('div',{staticClass:"article-text__text",class:[{'has-drop-cap': _vm.p.HasDropCap }],domProps:{"innerHTML":_vm._s(_vm.TextData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }